"use client";

/**
 * Responsive Popover Component — barrel re-export.
 *
 * The implementation has been split across `./responsive-popover/` to keep
 * each file under 300 lines. External consumers continue to import from
 * `@/components/ui/responsive-popover` exactly as before — names and types
 * are unchanged.
 *
 * For the full drawer/popover usage guide, see:
 * 📖 docs/ui-components/STANDARDIZED_DRAWER_README.md
 */

export { ResponsivePopover, useResponsivePopover } from "./responsive-popover/index";
export type { ResponsivePopoverProps } from "./responsive-popover/index";
